import { createContext, useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';
import invariant from 'tiny-invariant';

const PaymentFormContext = createContext<
  | (Pick<UseFormReturn, 'clearErrors' | 'register' | 'setError'> & {
      errors: UseFormReturn['formState']['errors'];
      isLoading: boolean | undefined;
    })
  | null
>(null);

export default PaymentFormContext;

export const usePaymentFormContext = () => {
  const context = useContext(PaymentFormContext);

  invariant(
    context,
    'usePaymentFormContext must be used within a PaymentFormContext',
  );

  return context;
};
